'use client';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@radix-ui/react-dropdown-menu';
import { Share2Icon } from '@radix-ui/react-icons';
import { useTranslations } from 'next-intl';
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from 'react-share';

import {
  actionButton,
  dropDownContent,
  shareActions,
  shareCopy,
  shareCopyButton,
  shareCopyText,
} from '@/app/[locale]/(new)/(public)/projects/[slug]/_page.css';
import { useToast } from '@/app/_components/ui/use-toast';

interface ShareOptionsProps {
  pageName: string;
}

interface ShareProps {
  pageName: string;
  isPageLocked: boolean;
}

const ShareOptions = ({ pageName }: ShareOptionsProps) => {
  const t = useTranslations();
  const { toast } = useToast();

  const shareUrl = window.location.href;

  const copyToClipBoard = () => {
    navigator.clipboard.writeText(shareUrl);
    toast({
      variant: 'success',
      description: t('common.copiedToClipboard'),
    });
  };

  return (
    <div className={dropDownContent}>
      <div className={shareActions}>
        <FacebookShareButton url={shareUrl}>
          <FacebookIcon round />
        </FacebookShareButton>
        <LinkedinShareButton url={shareUrl}>
          <LinkedinIcon round />
        </LinkedinShareButton>
        <TwitterShareButton url={shareUrl} title={pageName}>
          <XIcon round />
        </TwitterShareButton>
        <EmailShareButton url={shareUrl}>
          <EmailIcon round />
        </EmailShareButton>
        <WhatsappShareButton url={shareUrl}>
          <WhatsappIcon round />
        </WhatsappShareButton>
      </div>
      <div className={shareCopy}>
        <span className={shareCopyText}>{shareUrl}</span>
        <button className={shareCopyButton} onClick={() => copyToClipBoard()}>
          {t('common.copy')}
        </button>
      </div>
    </div>
  );
};

const Share = ({ pageName, isPageLocked }: ShareProps) => {
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger disabled={isPageLocked} asChild>
          <button className={actionButton}>
            <Share2Icon />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" sideOffset={10}>
          <ShareOptions pageName={pageName} />
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};

export default Share;
